<template>
  <main class="home">
    <div class="home-card">
      <h2 class="home-card-title">
        PDF在线转换
      </h2>
      <div class="home-card-body">
        <router-link to="/convert/pdfConvert/pdfToWord" class="home-card-item">
          <img src="../../assets/icon/home/icon_pdf2word.png"
               draggable="false"
               class="home-card-icon" alt="">
          <p class="home-card-des">PDF 转 Word</p>
        </router-link>
        <router-link to="/convert/pdfConvert/pdfToExcel" class="home-card-item">
          <img src="../../assets/icon/home/icon_pdf2excel.png"
               draggable="false"
               class="home-card-icon" alt="">
          <p class="home-card-des">PDF 转 Excel</p>
        </router-link>
        <router-link to="/convert/pdfConvert/pdfToPPT" class="home-card-item">
          <img src="../../assets/icon/home/icon_pdf2ppt.png"
               draggable="false"
               class="home-card-icon" alt="">
          <p class="home-card-des">PDF 转 PPT</p>
        </router-link>
        <router-link to="/convert/pdfConvert/pdfToImage" class="home-card-item">
          <img src="../../assets/icon/home/icon_pdf2jpg.png"
               draggable="false"
               class="home-card-icon" alt="">
          <p class="home-card-des">PDF 转 图片</p>
        </router-link>
        <router-link to="/convert/pdfConvert/pdfToTxt" class="home-card-item">
          <img src="../../assets/icon/home/icon_pdf2txt.png"
               draggable="false"
               class="home-card-icon" alt="">
          <p class="home-card-des">PDF 转 TXT</p>
        </router-link>
        <router-link to="/convert/convertToPdf/wordToPdf" class="home-card-item">
          <img src="../../assets/icon/home/icon_word2pdf.png"
               draggable="false"
               class="home-card-icon" alt="">
          <p class="home-card-des">Word 转 PDF</p>
        </router-link>
        <router-link to="/convert/convertToPdf/excelToPdf" class="home-card-item">
          <img src="../../assets/icon/home/icon_excel2pdf.png"
               draggable="false"
               class="home-card-icon" alt="">
          <p class="home-card-des">Excel 转 PDF</p>
        </router-link>
        <router-link to="/convert/convertToPdf/PPTToPdf" class="home-card-item">
          <img src="../../assets/icon/home/icon_ppt2pdf.png"
               draggable="false"
               class="home-card-icon" alt="">
          <p class="home-card-des">PPT 转 PDF</p>
        </router-link>
        <router-link to="/convert/convertToPdf/imageToPdf" class="home-card-item">
          <img src="../../assets/icon/home/icon_pdf2word.png"
               draggable="false"
               class="home-card-icon" alt="">
          <p class="home-card-des">图片 转 PDF</p>
        </router-link>
        <!--占位-->
        <a class="home-card-item" style="pointer-events: none;opacity: 0;"></a>
      </div>
    </div>
    <div class="home-card">
      <h2 class="home-card-title">
        CAD转化与PDF处理
      </h2>
      <div class="home-card-body">
        <router-link to="/convert/cadConvert/pdfToCad"
                     class="home-card-item">
          <img src="../../assets/icon/home/icon_pdf2cad.png"
               draggable="false"
               class="home-card-icon" alt="">
          <p class="home-card-des">PDF 转 CAD</p>
        </router-link>
        <router-link to="/convert/cadConvert/cadToPdf" class="home-card-item">
          <img src="../../assets/icon/home/icon_cad2pdf.png"
               draggable="false"
               class="home-card-icon" alt="">
          <p class="home-card-des">CAD 转 PDF</p>
        </router-link>
        <a class="home-card-item" style="opacity: 0;pointer-events: none;">
        </a>
        <a class="home-card-item" style="opacity: 0;pointer-events: none;">
        </a>
        <a class="home-card-item" style="opacity: 0;pointer-events: none;">
        </a>
      </div>
    </div>
    <div class="home-advantage">
      <h2 class="home-advantage-title">
        我们的优势
      </h2>
      <ul class="home-advantage-body">
        <li class="home-advantage-item">
          <img src="../../assets/icon/home/icon_1.png"
               draggable="false"
               class="home-advantage-icon"
               alt="">
          <p class="home-advantage-subtitle">
            信息安全
          </p>
          <p class="home-advantage-des">
            采用256位ssl加密传输技术让文件传输更安全更放心
          </p>
        </li>
        <li class="home-advantage-item">
          <img src="../../assets/icon/home/icon_1.png"
               draggable="false"
               class="home-advantage-icon"
               alt="">
          <p class="home-advantage-subtitle">
            信息安全
          </p>
          <p class="home-advantage-des">
            采用256位ssl加密传输技术让文件传输更安全更放心
          </p>
        </li>
        <li class="home-advantage-item">
          <img src="../../assets/icon/home/icon_1.png"
               draggable="false"
               class="home-advantage-icon"
               alt="">
          <p class="home-advantage-subtitle">
            信息安全
          </p>
          <p class="home-advantage-des">
            采用256位ssl加密传输技术让文件传输更安全更放心
          </p>
        </li>
        <li class="home-advantage-item">
          <img src="../../assets/icon/home/icon_1.png"
               draggable="false"
               class="home-advantage-icon"
               alt="">
          <p class="home-advantage-subtitle">
            信息安全
          </p>
          <p class="home-advantage-des">
            采用256位ssl加密传输技术让文件传输更安全更放心
          </p>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style lang="less" scoped>
@import "../../assets/style/styleVariable";
@import "../../assets/style/styleMixins";
.home{
  &-card{
    width: @page_width;
    margin: 20px auto;
    &-title{
      .flex_center_mixins;
      height: 50px;
      background: #F2F6FF;
      color: #548EF8;
    }
    &-body{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    &-item{
      .flex_center_mixins;
      width: 220px;
      height: 220px;
      box-sizing: border-box;
      flex-direction: column;
      box-shadow: 0 0 16px 0 rgba(58, 118, 229, 0.4);
      border-radius: 4px;
      margin-top: 20px;
      cursor: pointer;
      border: 2px solid transparent;
      transition: border-color .3s;
      &:hover{
        border-color:#548EF8;
      }
    }
    &-icon{
      height: 70px;
      width: 70px;
    }
    &-des{
      font-size: 18px;
      font-weight: 400;
      color: #333333;
      margin-top: 21px;
    }
  }
  &-advantage{
    background: #F9F9F9;
    padding-bottom: 133px;
    &-title{
      font-size: 28px;
      color: #333333;
      display: block;
      padding: 59px 0 47px 0;
      text-align: center;
    }
    &-body{
      width: @page_width;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
    &-item{
      width: 237px;
      .flex_center_mixins;
      flex-direction: column;
    }
    &-icon{
      height: 140px;
      width: 140px;
    }
    &-subtitle{
      margin: 20px 0 18px 0;
      font-size: 18px;
      color: #333333;
    }
    &-des{
      font-size: 14px;
      color: #666666;
      line-height: 24px;
    }
  }
}
</style>
